<template>
  <datatable
      :type="'workers'"
      :rowData="workers"
      :loadingMessage="loadingMessage"
      :noRowsMessage="noRowsMessage"
      :columns="columns"
      :paginationSize="50"
  />
</template>

<script>
import datatable from "datatables/datatable";

export default {
  name: 'all_workers',
  components: { datatable },

  data() {
    return {
      workers: null,
      loadingMessage: 'Loading Workers...',
      noRowsMessage: 'No Workers Found',

      columns: [
        {
          headerName: 'Ref',
          width: 100,
          pinned: 'left',
          suppressSizeToFit: true,
          valueGetter: this.worker_cross_ref,
          getQuickFilterText: params => {
            return `${params.data.internal_finance_ref ?? ''} ${params.data.company_internal_finance_ref ?? ''}`;
          },
          cellRenderer: params => {
            const el = document.createElement('span');
            el.innerHTML = params.value || '';
            return el;
          }
        },
        { headerName: 'Name', field: 'full_name', pinned: 'left', minWidth: 225 },
        { headerName: 'Working For', minWidth: 300, valueGetter: this.working_for_vg, cellStyle: {'white-space':'pre-wrap'} },
        { headerName: 'Job Title', field: 'job_title', minWidth: 140 },
        { headerName: 'NI', field: 'ni_number', minWidth: 100 },
        { headerName: 'UTR', field: 'personal_utr_number', minWidth: 110 },
        { headerName: 'Email', field: 'email_address', minWidth: 225 },
        { headerName: 'Mobile', field: 'phone_number', minWidth: 95 },
        { headerName: 'Last Updated', minWidth: 140, valueGetter: this.latest_update_vg },
        { headerName: 'Trading As', field: 'company_trading_name', minWidth: 200 },
        { headerName: 'Tax', field: 'genius_tax', minWidth: 85 },
      ]
    }
  },

  mounted() {
    this.get_workers();
  },

  methods: {
    get_workers() {
      let route = this.$router.currentRoute.name;

      const map = {
        assigned_workers: 'sunset/workers/assigned',
        unassigned_workers: 'sunset/workers/unassigned',
        verified_workers: 'sunset/workers/verified',
        unverified_workers: 'sunset/workers/unverified',
        all_workers: 'sunset/workers'
      };

      const ep = map[route] || 'sunset/workers';

      axios.get(this.crmApiPath + ep)
          .then(res => this.workers = res.data)
          .catch(err => console.error(err?.response || err));
    },

    worker_cross_ref(p) {
      if (p.data.company_internal_finance_ref) {
        return `C: ${p.data.company_internal_finance_ref}<br>W: ${p.data.internal_finance_ref}`;
      }
      return p.data.internal_finance_ref;
    },

    working_for_vg(p) {
      const companies = p.data.unique_company_assignments || {};
      return Object.values(companies).join('\n');
    },

    latest_update_vg(p) {
      return p.data.latest_update ? this.$options.filters.formatDateTime(p.data.latest_update) : '';
    }
  }
}
</script>
